import { useQuery } from "react-query";
import React, { memo } from "react";
import { fetchGetNetFriendHotSearch } from "@Services/api";

const NetFriendHotSearch: React.FC = () => {
  const { data } = useQuery(
    `fetchGetNetFriendHotSearch`,
    async () => {
      const res = await fetchGetNetFriendHotSearch();
      if (res?.status === 12000) {
        return res.data;
      }
    },
    { initialData: { list: [] } },
  );

  return (
    <section className={"w-full m-auto relative"} style={{ minHeight: data.list.length > 0 ? "964px" : "0" }}>
      {data.list.length > 0 && (
        <>
          <p className={"font-bold text-24 text-[#333] mb-20 leading-32"}>網友熱搜</p>
          <div className={"flex flex-wrap"}>
            {data.list.map((item, index) => (
              <div className={`mb-40 ${(index === 2 || index === 5) ? 'pr-0 mr-0 border-0' : 'pr-36 mr-36 border-0 border-r-1 border-solid border-[#999]'}`} key={index}>
                <p className={"text-16 text-[#666] leading-24 font-bold"}>{item.name}</p>
                {item.list.length > 0 &&
                  item.list.map((res, idx) => (
                    <div className={"py-8 flex justify-start items-center border-0 border-b-1 border-solid border-[#e8e8e8] w-[268px]"} key={res.id}>
                      <p className={"w-16 h-16 flex items-center justify-center rounded-4 text-14 mr-12 text-white"} style={{ backgroundColor: idx > 2 ? "#C1D0FF" : "#3264ff" }}>
                        {idx + 1}
                      </p>
                      <div
                        className={"flex justify-between flex-1 items-center text-14"}
                        onClick={() => {
                          window.open(res.url, "_blank");
                        }}
                      >
                        <p className={"text-[#333] flex-1 cursor-pointer leading-22"}>{res.fullName}</p>
                        <p className={"text-[#999]"}>{res.autoType}</p>
                      </div>
                    </div>
                  ))}
              </div>
            ))}
          </div>
        </>
      )}
    </section>
  );
};

export default memo(NetFriendHotSearch);
